export default __webpack_public_path__ + "0bca547498ce80b05707a9f1cfc37a2c.png";